<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" v-if="po">
                <div class="card-header pb-0">
                    <div class="justify-content-between d-flex">
                        <button 
                            type="button"
                            @click="download"
                            :class="'btn btn-xs btn-outline-primary text-xs font-weight-normal m-0 ' + (loading ? 'disabled' : '')">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                            <i class="fa fa-download" v-if="!loading"></i> Download PO
                        </button>
                        <argon-badge variant="gradient" color="primary" class="text-xxs align-self-center" v-if="po && po.state">{{ po.state }}</argon-badge>
                    </div>
                    <hr/>
                </div>
                <div class="card-body min-vh-50 pt-0">
                    <h5>#{{ po.name }}</h5>
                    <div class="row">
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Vendor</td>
                                        <td class="font-weight-bold">{{ po.partner_name }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Vendor Code</td>
                                        <td class="font-weight-bold">{{ po.partner_code }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Warehouse</td>
                                        <td class="font-weight-bold">{{ po.warehouse }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Payment Terms</td>
                                        <td class="font-weight-bold">{{ po.payment_term_id }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-sm-6">
                            <table class="text-sm" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="30%">Order Date</td>
                                        <td class="font-weight-bold">{{ po.date_order }}</td>
                                    </tr>   
                                    <tr>
                                        <td class="text-secondary">Receipt Date</td>
                                        <td class="font-weight-bold">{{ po.date_planned }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Vendor Forecast</td>
                                        <td class="font-weight-bold">{{ po.vendor_forecast }}</td>
                                    </tr>
                                    <tr>
                                        <td class="text-secondary">Projects</td>
                                        <td class="font-weight-bold">
                                            <p class="text-sm mb-0 pl-1">
                                                <argon-badge style="margin-left: 2px;" v-for="project in po.project_ids" :key="project.id" 
                                                color="secondary"
                                                size="sm">{{ project.name }}
                                                </argon-badge>
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table-responsive p-0 mt-3">
                        <table class="table align-items-center mb-0">
                            <thead>
                                <tr class="bg-light">
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">#</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Product</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Description</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Projects</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Quantity</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Unit Price</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Taxes</th>
                                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Subtotal</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="line,i in po.order_line" :key="line.id">
                                    <td class="text-xs mb-0 ps-2">{{ i+1 }}</td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.name }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0">{{ line.name }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs mb-0">
                                            <argon-badge style="margin-left: 2px;" v-for="project in line.project_ids" :key="project.id" 
                                            color="secondary"
                                            size="sm">{{ project.name }}
                                            </argon-badge>
                                            <span @click="showLineProjectDetail(line.id)" v-if="line.project_ids && line.project_ids.length > 0" style="margin-left: 5px;cursor: pointer;"
                                                data-bs-toggle="modal" data-bs-target="#projectPurchaseLine">
                                                <i class="fa fa-info-circle" aria-hidden="true"></i>
                                            </span>
                                        </p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0">{{ line.product_qty }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0">{{ line.price_unit }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0" v-for="tax,i in line.taxes_id" :key="i">{{ tax }}</p>
                                    </td>
                                    <td>
                                        <p class="text-xs text-end mb-0 px-2">{{ line.price_subtotal }}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- modal -->
                    <div class="modal fade" id="projectPurchaseLine" tabindex="-1" aria-labelledby="projectPurchaseLinelabel" aria-hidden="true">
                      <div class="modal-dialog modal-xl modal-dialog-scrollable">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="projectPurchaseLinelabel">Purchase Line Project List</h5>
                            <button type="button" class="btn btn-light" data-bs-dismiss="modal">X</button>
                          </div>
                          <div class="modal-body">
                            <div class="table-responsive p-0 mt-3">
                              <table class="table align-items-center mb-0">
                                  <thead>
                                      <tr class="bg-light">
                                          <th class="text-uppercase text-xs font-weight-bolder opacity-7 ps-2">#</th>
                                          <th class="text-uppercase text-xs font-weight-bolder opacity-7 ps-2">Product</th>
                                          <th class="text-uppercase text-xs font-weight-bolder opacity-7 ps-2">Projects</th>
                                          <th class="text-uppercase text-xs font-weight-bolder opacity-7 ps-2">Quantity</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="line,i in modal.project_rfq_line" :key="line.id">
                                      <td class="text-sm mb-0 ps-2">{{ i+1 }}</td>
                                      <td class="text-sm mb-0 ps-2">{{ line.product_name }}</td>
                                      <td class="text-sm mb-0 ps-2">{{ line.project_name }}</td>
                                      <td class="text-sm mb-0 ps-2">{{ line.product_qty }}</td>
                                    </tr>
                                  </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md">
                            <table class="text-sm " width="100%">
                                <tbody>
                                    <tr>
                                        <td class="text-secondary" width="50%">Terms and Conditions:</td>
                                        
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold"><pre class="text-sm font-weight-bold">{{ po.notes }}</pre></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-4 px-4">
                            <table class="text-sm font-weight-bold" width="100%">
                                <tbody>
                                    <tr>
                                        <td class="" width="50%">Untaxed Amount</td>
                                        <td class="text-end">{{ po.amount_untaxed }}</td>
                                    </tr>   
                                    <tr>
                                        <td class="">Amount Tax</td>
                                        <td class="text-end">{{ po.amount_tax }}</td>
                                    </tr>
                                    <tr>
                                        <td class="border-top">Amount Total</td>
                                        <td class="border-top font-weight-bold text-end">{{ po.amount_total }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from '../components/ArgonBadge.vue'
const endpoint = require(("../router/endpoint"))

export default {
    name: 'po-detail',
    data () {
        return {
            po: null,
            loading: false,
            modal: {
                project_po_line: null,
            },
        }
    },
    components: {
        ArgonBadge
    },
    methods: {
        showLineProjectDetail(lineId){
        this.axios
            .post(
            endpoint.PURCHASE_PROJECT_LIST,
            {
                purchase_line_id: lineId
            },
            {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }
            )
            .then((response) => {
            if (response.data.response_code === "0000") {
                this.modal.project_rfq_line = response.data.data;
                console.log(response.data.data)
            } else {
                this.$notify({
                    type: 'warn',
                    title: 'Warning',
                    text: response.data.message,
                });
            }
            })
            .catch((e) => {
            this.$notify({
                type: 'error',
                title: 'Something went wrong!',
                text: e.response.data.message,
            });
            this.loading = false;
            this.$router.replace('/rfq')
            });
        },
        getPODetail() {
            this.axios
                .post(
                endpoint.PO_DETAIL,
                {
                    id: this.$route.params.id,
                },
                {
                    headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
                )
                .then((response) => {
                if (response.data.response_code === "0000") {
                    this.po = response.data.data;
                } else {
                    this.$notify({
                        type: 'warn',
                        title: 'Warning',
                        text: response.data.message,
                    });
                    this.loading = false;
                }
                })
                .catch((e) => {
                this.loading = false;
                this.$notify({
                    type: 'error',
                    title: 'Something went wrong!',
                    text: e.response.data.message,
                    });
                });
        },
        download () {
            this.loading = true
            this.axios
                .post(
                endpoint.DOWNLOAD,
                {
                    res_id: this.$route.params.id,
                    template_report: 'bh_purchase_request.action_report_po'
                },
                {
                    headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                    }
                }
                )
                .then((response) => {
                if (response.data.response_code === "0000") {
                    const linkSource = `data:application/pdf;base64,${response.data.data.file}`;
                    const downloadLink = document.createElement("a");
                    const fileName = this.po.name + ".pdf";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                } else {
                    if (response.data.response_code !== "4000"){
                    this.$notify({
                        type: 'warn',
                        title: 'Warning',
                        text: response.data.message,
                    });
                    }
                }
                this.loading = false
                })
                .catch((e) => {
                this.loading = false;
                this.$notify({
                    type: 'error',
                    title: 'Something went wrong!',
                    text: e.response.data.message,
                    });
                });
        }
    },
    mounted () {
        this.getPODetail()
    }
}
</script>

<style>

</style>